export default function UserIcon() {
  return (
    <>
      <g id='Profile'>
        <g id='Profile_2'>
          <path
            id='Stroke 1'
            d='M12.147 15.3438C8.27942 15.3438 4.97656 15.9285 4.97656 18.2704C4.97656 20.6123 8.25847 21.218 12.147 21.218C16.0147 21.218 19.3166 20.6323 19.3166 18.2914C19.3166 15.9504 16.0356 15.3438 12.147 15.3438Z'
          />
          <path
            id='Stroke 3'
            d='M12.1509 12.0039C14.689 12.0039 16.7461 9.94584 16.7461 7.40774C16.7461 4.86964 14.689 2.8125 12.1509 2.8125C9.61281 2.8125 7.55471 4.86964 7.55471 7.40774C7.54614 9.93726 9.58995 11.9954 12.1185 12.0039H12.1509Z'
          />
        </g>
      </g>
    </>
  );
}
